import { Alert, Box, Stack } from "@mui/material";
import useEmbedded from "../../../hooks/useEmbedded";
import { ChangeEvent } from "react";
import MarketingCheckboxes from './MarketingCheckboxes';
import CustomerRelatedFields from './CustomerRelatedFields';

type InvitationAcceptanceFieldsProps = {
  isSubmittingAgreement: boolean;
  handleTermsAgreementChange: (event: ChangeEvent<HTMLInputElement>) => void;
  handlePromotionChange: (event: any) => void;
  isSendMonthlyNewsletter: boolean;
  errors: any;
  showPassword: boolean;
  setShowPassword: (flag: boolean) => void;
  localStorageAccessible: boolean;
  isInvitationAcceptace?: boolean;
  isExistingUser?: boolean;
};

export default function InvitationAcceptanceFields({
  isSubmittingAgreement,
  handleTermsAgreementChange,
  handlePromotionChange,
  errors,
  isSendMonthlyNewsletter,
  showPassword,
  setShowPassword,
  localStorageAccessible,
  isInvitationAcceptace,
  isExistingUser,
}: InvitationAcceptanceFieldsProps) {

  const { isEmbedded } = useEmbedded();

  return (<>
    <Stack spacing={2} sx={{ my: 2 }}>
      {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
      <CustomerRelatedFields 
        includePasswordField={(!isEmbedded || localStorageAccessible)}
        includeBusinessNameField={false}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        disableEmailField={true}
        hideEmailField
        isExistingUser={isExistingUser}
      />

      {isInvitationAcceptace && <Box sx={{ pt: 2 }} />}

      <MarketingCheckboxes
        isSubmittingAgreement={isSubmittingAgreement}
        handleTermsAgreementChange={handleTermsAgreementChange}
        handlePromotionChange={handlePromotionChange}
        isSendMonthlyNewsletter={isSendMonthlyNewsletter}
      />
    </Stack>

  </>)

}
